var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.765641 3.11717L3.2858 0.531777C3.61395 0.195137 4.14686 0.195137 4.47501 0.531777C4.80315 0.868416 4.80315 1.41512 4.47501 1.75176L3.39344 2.86132H6.39926C8.71466 2.86132 10.5995 4.79498 10.5995 7.17031C10.5995 9.54564 8.71466 11.4793 6.39926 11.4793C5.9346 11.4793 5.5592 11.0942 5.5592 10.6175C5.5592 10.1408 5.9346 9.7557 6.39926 9.7557C7.78797 9.7557 8.91942 8.59497 8.91942 7.17031C8.91942 5.74565 7.78797 4.58492 6.39926 4.58492H3.38031L4.46713 5.69987C4.79528 6.03651 4.79528 6.58321 4.46713 6.91985C4.30437 7.08682 4.08911 7.173 3.87384 7.173C3.65858 7.173 3.44332 7.08952 3.28055 6.91985L0.765641 4.33446C0.437495 3.99782 0.437495 3.45381 0.765641 3.11717Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/Undo.00e3f68a1448347ca878d3e01ded32b0.svg";
export { ForwardRef as ReactComponent };